import { DisctionaryContent } from "src/app/services/sitecoreDictionary/dictionary-content.service";
import { ChangeDetectorRef, Component, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, Validators, ReactiveFormsModule } from '@angular/forms';
import { MatTableDataSource, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow } from '@angular/material/table';
import { Subject, combineLatest, takeUntil } from 'rxjs';
import { CardDetails } from 'src/app/models/interface/cam.interface';
import { ApiService } from 'src/app/services/apiService/api.service';
import { CamService } from 'src/app/services/camService/cam.service';
import { noHtmlTagsValidator } from 'src/app/shared/Validators/special-character-validation';
import { luhnValidator } from 'src/app/shared/Validators/luhnValidator';
import { CommonService } from 'src/app/shared/common/common.service';
import { ToastrApiService } from 'src/app/shared/common/toastr-api.service';
import { ContentService } from '../../services/content.service';
import { LocalSessionStorage } from 'src/app/models/interface/FlightSearch/CommanModel.interface';
import { MatDialog, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { TravelerManagement } from 'src/app/services/dataLayer/CAM/traveler-management.service';
import { NgIf, NgFor } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { MatFormField, MatLabel, MatError, MatSuffix } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/autocomplete';
import { MatRadioGroup, MatRadioButton } from '@angular/material/radio';
import { MatButton } from '@angular/material/button';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { CamEmptyStateComponent } from '../cam-empty-state/cam-empty-state.component';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { CardNumberFormatPipe } from '../../../../shared/pipes/card-number-format.pipe';
import { ErrorStateMatcher } from '@angular/material/core';
import { CryptoService } from 'src/app/services/commonService/crypto.service';
import { ContentDialogComponent } from 'src/app/shared/components/dialogs/content-dialog/content-dialog.component';
import { CompanyManagementContentService } from '../../services/company-management-content.service';
import { BookingContentService } from "src/app/services/bookingContentService/booking-content.service";

export class CardErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: AbstractControl | null, form: any): boolean {
    return !!(control && control.invalid && (control.dirty || control.touched));
  }
}

interface CreditCardDetail {
  Status: string;
  CardNumber: string;
  ExpiryDate: string;
  Actions: string;
}


@Component({
  selector: 'app-saved-cards',
  templateUrl: './saved-cards.component.html',
  styleUrls: ['./saved-cards.component.scss'],
  imports: [ReactiveFormsModule, NgIf, MatIcon, MatFormField, MatLabel, MatInput, MatError, MatSuffix, MatSelect, NgFor, MatOption, MatRadioGroup, MatRadioButton, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, MatButton, MatProgressSpinner, CamEmptyStateComponent, CdkScrollable, MatDialogContent, MatDialogActions, CardNumberFormatPipe]
})
export class SavedCardsComponent implements OnInit, OnDestroy {
  dictionaryContentData: any = null;
  matcher = new CardErrorStateMatcher();
  years: { value: number, isDisabled: boolean }[] = [];
  months: { value: string; name: string, index: number }[] = [];
  displayedColumns: string[] = ['position', 'name', 'weight', 'symbol'];
  // dataSource = ELEMENT_DATA;
  SaveCardForm: FormGroup;
  Cardoption: any;
  CardTypes: any;
  displayedColumns1: string[] = ['Card_Name', 'Card_option', 'Card_Type', 'Holder_Name', 'Card_Number', 'CardExpiry', 'Actions'];
  //dataSource1 = new MatTableDataSource([]);
  dataSource1: MatTableDataSource<CreditCardDetail> = new MatTableDataSource<CreditCardDetail>([]);
  userId: string = '';
  saUser_Guid: string = '';
  guid: any;
  companySettingDetails: any = {};
  // isProfileViewRestricted: boolean = false;
  cardId: any;
  userData: any[] = [];
  Addnew: boolean = false;
  saveCardAs: boolean = true;
  Loader: any = {
    isSpinner: false,
    isEditableClicked: false
  }
  noDataPersonalInfo!: boolean
  content: any;
  isTAEditMode: boolean = true;
  loginType: any;
  @ViewChild('selectionWarning') selectionWarning!: TemplateRef<any>;
  cardID: any;
  private destroy$ = new Subject<void>();
  numberOfResult: number = 0;
  companyManagementContent: any;
  constructor(private readonly bookingContentService: BookingContentService, private fb: FormBuilder, private _CamApiService: CamService,
    public _ApiService: ApiService, private cdr: ChangeDetectorRef,
    private _ToastrApiService: ToastrApiService,
    public _CommonService: CommonService, private readonly dialog: MatDialog,
    private readonly contentService: ContentService,
    private readonly dictionaryContentService: DisctionaryContent,
    private readonly travelerManagement: TravelerManagement,
    private readonly crypto: CryptoService,
    private readonly companyManagementContentService: CompanyManagementContentService
  ) {
    this.SaveCardForm = this.fb.group({
      cardName: ['', [Validators.minLength(2), Validators.maxLength(50)]],
      cardOption: ['', [Validators.required, noHtmlTagsValidator(),],],
      cardType: ['', [Validators.required, noHtmlTagsValidator(),],],
      cardHolderName: ['', [Validators.required, Validators.minLength(2), Validators.maxLength(50), Validators.pattern(/^[a-zA-Z\s]+$/)]],
      cardNumber: ['', [Validators.required, Validators.minLength(13), Validators.maxLength(19), this.cardNumberValidator, luhnValidator()]],
      expiryMonth: ['', [Validators.required,]],
      expiryYear: ['', [Validators.required,]],
      saveCardAs: ['1', [Validators.required,]],
      guid: ['',],
    });
    this.initializeMonthsAndYears();
  }

  handleEvent(event: string) {
    if (!this.isTAEditMode) {
      return;
    }
    this.travelerManagement.traveler_click
    if (event.includes('saved-cards')) {
      // GTM Event Call
      if (this.dataSource1.data.length > 0 && !this.Addnew) {
        this.travelerManagement.saved_card_click(this.numberOfResult, 'Add new card');
      }

      this.SaveCardForm.reset();
      this.SaveCardForm.get("saveCardAs")?.setValue('1');
      this.Addnew = true;
    }
  }

  ngOnInit(): void {
    combineLatest({
      content: this.contentService.content$, dictionary: this.dictionaryContentService.content$
    }).pipe(takeUntil(this.destroy$)).subscribe((res: any) => {
      this.content = {
        ...res.content,
        dictionary: res.dictionary
      }
    });

    this.companyManagementContentService.content$.pipe(takeUntil(this.destroy$)).subscribe((res: any) => {
      this.companyManagementContent = res;
    });


    this.userId = sessionStorage.getItem('userId') || '';
    this.guid = sessionStorage.getItem('guid') || '';
    this.loginType = this.crypto.getValueFromKey('ISCORPTRAVELARRANGER') as string;
    this.syncTAEditMode();
    const stored = localStorage.getItem(LocalSessionStorage.COMPANY_SETTINGS) ?? sessionStorage.getItem(LocalSessionStorage.COMPANY_SETTINGS);
    this.companySettingDetails = stored && stored !== 'undefined' ? JSON.parse(stored) : {};
    // const travelerGUID = localStorage.getItem('travelerGUID')?.toLowerCase();
    // const userGuid = localStorage.getItem('userGuid')?.toLowerCase();
    // this.isProfileViewRestricted = this.companySettingDetails?.restrictAmendmentInTravelerProfile && (travelerGUID !== userGuid);
    // if (this.isProfileViewRestricted) {
    //   this.displayedColumns1 = ['Card_Name', 'Card_option', 'Card_Type', 'Holder_Name', 'Card_Number', 'CardExpiry'];
    // }
    if (this.userId && this.guid) {
      this.loadCarddetails();
    }
    this.noDataPersonalInfo = this._CommonService.getData('camSidebar')
      this.bookingContentService.content$.subscribe((res: any) => { this.content = { ...(this.content || {}), ...(res || {}) }; });
  }

  /** TA can edit only when opened profile SA_User_ID matches logged-in USERID. */
  private syncTAEditMode(): void {
    if (String(this.loginType) === '1') {
      const selectedUserId = String(this.userId || sessionStorage.getItem('userId') || '');
      const loggedInUserId = String(this.crypto.getValueFromKey('USERID') || '');
      this.isTAEditMode = !!loggedInUserId && selectedUserId === loggedInUserId;
    } else {
      this.isTAEditMode = true;
    }
    const baseCols = ['Card_Name', 'Card_option', 'Card_Type', 'Holder_Name', 'Card_Number', 'CardExpiry'];
    this.displayedColumns1 = this.isTAEditMode ? [...baseCols, 'Actions'] : baseCols;
  }
  getUserRole(): string {
    const travelArranger = this.crypto.getValueFromKey(
      'ISCORPTRAVELARRANGER'
    ) as string;

    switch (travelArranger) {
      case '0':
        return 'Admin';
      case '1':
        return 'TravelArranger';
      case '2':
        return 'Employee';
      default:
        return '';
    }
  }
  loadCarddetails() {
    this._CamApiService.GetCreditCardDetails(this.guid, this.userId)
      .then((response: any) => {
        if (response?.status === 'Success') {

          if (response.data?.[0]?.Status !== 'USERIDGUIDMISMATCH') {
            this.userData = response.data;

            this.dataSource1.data = response.data.cardDetailsList; // important

            this.CardTypes = response.data.cardType;
            this.Cardoption = response.data.CardOption;
          }
          else {
            this.dataSource1.data = [];
          }

        }
      })
      .catch((error: any) => {
        console.error(error);
      });
  }

  // Initialize months and years
  initializeMonthsAndYears() {
    this.months = Array.from({ length: 12 }, (_, i) => ({
      index: i,
      value: new Date(2000, i).toLocaleString('en-US', { month: 'short' }).toUpperCase(), // 'Jan', 'Feb', etc.
      name: new Date(2000, i).toLocaleString('en-US', { month: 'long' })   // 'January', 'February', etc.
    }));
    const currentYear = new Date().getFullYear();
    this.years = Array.from({ length: 11 }, (_, i) => ({
      value: currentYear + i,
      isDisabled: false
    }));
  }

  // Validator for expiry date
  checkPastMonth() {
    let expiryMonth = this.SaveCardForm.get('expiryMonth')?.value;
    const currentMonth = new Date().getMonth() + 1; // JavaScript months are 0-based

    // Convert month abbreviation to numeric month
    const monthMapping: { [key: string]: number } = {
      JAN: 1, FEB: 2, MAR: 3, APR: 4, MAY: 5, JUN: 6,
      JUL: 7, AUG: 8, SEP: 9, OCT: 10, NOV: 11, DEC: 12
    };

    expiryMonth = monthMapping[expiryMonth]; // Convert "JAN" -> 1

    let currentYear = new Date().getFullYear();
    if (expiryMonth < currentMonth) {
      currentYear++; // Move to next year if the selected month is in the past
    }

    // Generate years from the determined starting year
    this.years = Array.from({ length: 11 }, (_, i) => ({
      value: currentYear + i,
      isDisabled: false
    }));
  }

  Cancel(): void {
    this.SaveCardForm.reset();
    this.SaveCardForm.get("saveCardAs")?.setValue('1');
    this.Addnew = false;

    // GTM Event Call
    if (this.dataSource1.data.length > 0 && !this.Addnew) {
      this.travelerManagement.traveler_detail_click('Cancel');
    } else {
      this.travelerManagement.traveler_detail_clickBackStep('Cancel');
    }
  }

  cardNumberValidator(control: AbstractControl): ValidationErrors | null {
    if (!control || !control.parent) {
      return null;
    }

    // Get raw value and remove all non-digit characters (including hyphens)
    const rawValue = control.value || '';
    const cleanCardNumber = rawValue.replace(/\D/g, ''); // ये सब हटा देगा: -, spaces, etc.

    const cardType = control.parent.get('cardType')?.value; // Get selected card type

    if (cleanCardNumber && cardType) {
      let isValidCard = true;
      switch (cardType) {
        case 'AX':
          isValidCard = /^3[47][0-9]{13}$/.test(cleanCardNumber);
          break;
        case 'VI':
          isValidCard = /^4[0-9]{12}(?:[0-9]{3})?$/.test(cleanCardNumber);
          break;
        case 'CA':
          isValidCard = /^(5[1-5][0-9]{14}|2[2-7][0-9]{14})$/.test(cleanCardNumber);
          break;
        default:
          isValidCard = true;
          break;
      }
      if (!isValidCard) {
        return { invalidCard: true };
      }
    }
    return null;
  }

  setCarNumberNull(): void {
    this.SaveCardForm.get('cardNumber')?.setValue('');
  }
  // Restrict input to numbers only
  numberValidator(event: KeyboardEvent) {
    const allowedKeys = ['Backspace', 'Tab', 'ArrowLeft', 'ArrowRight'];
    if (!/^\d$/.test(event.key) && !allowedKeys.includes(event.key)) {
      event.preventDefault();
    }
  }

  blockDigits(event: KeyboardEvent): void {
    const allowedKeys = /^[a-zA-Z\s]$/;
    if (!allowedKeys.test(event.key) && event.key !== 'Backspace' && event.key !== 'Tab') {
      event.preventDefault();
    }
  }

  addUpdateCardDetails() {
    if (this.SaveCardForm.valid) {
      // GTM Event Call
      if (this.dataSource1.data.length > 0) {
        this.travelerManagement.traveler_detail_click('Save');
      } else {
        this.travelerManagement.traveler_detail_clickBackStep('Save');
      }

      if (this.SaveCardForm.get('saveCardAs')?.value === '1') {
        this.saveCardAs = true;
      }
      else {
        this.saveCardAs = false;
      }

      const data: CardDetails = {
        cardNumber: this.SaveCardForm.get('cardNumber')?.value.replace(/-/g, '') || '',
        cardHolderName: this.SaveCardForm.get('cardHolderName')?.value || '',
        cardOption: this.SaveCardForm.get('cardOption')?.value || '',
        cardType: this.SaveCardForm.get('cardType')?.value || '',
        cardName: this.SaveCardForm.get('cardName')?.value || '',
        expiryYear: this.SaveCardForm.get('expiryYear')?.value || new Date().getFullYear(),
        expiryMonth: this.SaveCardForm.get('expiryMonth')?.value,
        isSaveCardDetails: this.saveCardAs,
        queryNo: this.Loader.isEditableClicked ? 7 : 6,
        ...(this.Loader.isEditableClicked && { guid: this.SaveCardForm.get('guid')?.value })
      };

      this._CamApiService.addUpdateCards(data, this.userId).then(($res: any) => {
        if ($res?.status === 'Success') {
          this._ToastrApiService.show("success", "Card saved successfully.")
          this.SaveCardForm.reset();
          this.Addnew = false;
          this.loadCarddetails();

        }
        else {
          this._ToastrApiService.show("error", "Your insert is getting failed due to dublicate record")
        }
      }).catch(($err: any) => {
        const message =
          $err?.error?.message || this.dictionaryContentData?.['b2b.managetraveler.entervalidcardno'] || this.dictionaryContentData?.phrases?.b2b?.managetraveler?.entervalidcardno || 'Please Enter a valid card Number.';
        console.error('Error add Update Card Details:', $err);
        this._ToastrApiService.show("error", message);
      });
    }
    else {
      this.SaveCardForm.markAllAsTouched();
      this.SaveCardForm.markAsDirty();
    }
  }

  bindSaveCardForm(data: any) {
    let CardAs = '';
    this.Loader.isEditableClicked = true;
    this.Addnew = true;
    if (data.Is_Personal_Card === true) {
      CardAs = '1'
    }
    else {
      CardAs = '2'
    }

    this.SaveCardForm.patchValue({
      cardName: [data.Card_Name || ''],
      cardOption: [data.Card_Option || ''],
      cardType: [data.Card_Type_Code || ''],
      cardHolderName: [data.Name_on_Card || ''],
      cardNumber: [data.Card_Number || ''],
      expiryMonth: Number(data.Exp_Month),
      expiryYear: [data.CardExpiry1 || ''],
      saveCardAs: [CardAs || '',],
      guid: [data.GUID || '',],
    });
    this.SaveCardForm.get("cardNumber")?.disable();
    //this.SaveCardForm.disable();
    // return this.SaveCardForm;
  }

  deleteThisCard(Id: any) {
    // GTM Event Call
    this.travelerManagement.saved_card_click(this.numberOfResult, 'Remove');
    this.cardID = Id;
    this.dialog.open(this.selectionWarning, {
      data: Id,
    });
  }

  confirmDelete() {
    this._CamApiService.deleteSavedCard(this.cardID).then(($res: any) => {
      if ($res.status == "Success") {
        this.travelerManagement.card_remove_success_click('Remove Card Success', 'Success');
        this._ToastrApiService.show('success', "Card deleted successfully.");
        this.cardID = undefined;
        this.loadCarddetails();
      }
      else {
        this._ToastrApiService.show("error", "Failed to delete data.")
      }
    }).
      catch(($err: any) => { console.error('Error on delete Card Details:', $err); });
  }

  // CloseDialog1(result: boolean) {
  //   if (result) {
  //     this.confirmDelete();
  //   }
  //   this.dialog.closeAll(); // Closes the dialog
  // }

  CloseDialog(result: boolean) {
    if (result) {
      this.travelerManagement.save_card_remove_click('Confirm', 'Proceed');
      this.confirmDelete();
    } else {
      this.travelerManagement.save_card_remove_click('Cancel', 'Cancel');
    }

    this.dialog.closeAll(); // Closes the dialog
  }



  maskCardNumber(cardNumber: string): string {
    // Get last 4 digits
    const last4 = cardNumber.slice(-4);
    return `XXXX${last4}`;
  }
  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}

export interface PeriodicElement {
  name: string;
  position: number;
  weight: number;
  symbol: string;
}

